"use client";

import { useMemo } from "react";

import { LanguageSelectorBase } from "./LanguageSelectorBase";

import { useLanguagePreference } from "@/hooks/language";

import type { LanguageSelectorChangeHandler, LanguageSelectorProps } from "./types";
import { LanguageCode } from "@/types/languages";

// eslint-disable-next-line prettier/prettier
interface LanguageSelectorPropsWithPersistence extends Omit<
  LanguageSelectorProps,
  "value" | "onChange"
> {
  onLanguageChange?: LanguageSelectorProps["onChange"];
}

export const LanguageSelector = ({
  onLanguageChange,
  disabled,
  ...rest
}: LanguageSelectorPropsWithPersistence) => {
  const { locale, handleLanguageChange, isNavigating, navigateToLocale } = useLanguagePreference();

  const isDisabled = useMemo(() => disabled || isNavigating, [disabled, isNavigating]);

  const handleSelectorChange: LanguageSelectorChangeHandler = (nextLocale, option) => {
    handleLanguageChange(nextLocale as LanguageCode);
    navigateToLocale(nextLocale as LanguageCode);
    onLanguageChange?.(nextLocale, option);
  };

  return (
    <LanguageSelectorBase
      value={locale}
      onChange={handleSelectorChange}
      disabled={isDisabled}
      {...rest}
    />
  );
};
